export default __webpack_public_path__ + "static/media/icn-megaphone-plus.271128fc.svg";